import * as $ from 'jquery';

(function testimonialSlides() {
	function randomizer(elems) {
		return Math.floor(Math.random() * elems.length);
	}

	var nextButton = $("#next");
	var prevButton = $("#previous");
	var slides = $("#testimonial-slides .testimonial");
	var slideCount = slides.length;
	var randomIndex = randomizer(slides);
	var slideController = new SlideController(slides, randomIndex);
	var firstSlide = slideController.currentSlide();

	function SlideController(slides, startingIndex) {
		if (typeof startingIndex !== "undefined") {
			this.index = startingIndex;
		} else {
			this.index = 0
		}

		this.getIndex = function () {
			return this.index;
		};

		this.setIndex = function (index) {
			this.index = index;
		};

		this.slides = slides;

		this.newSlide = function (direction) {
			var slide;

			if (direction === "next") {
				var index = this.getIndex();
				if (index + 1 >= slideCount) {
					slide = slides[0];
					this.setIndex(0);
				} else {
					slide = slides[index + 1];
					this.setIndex(index + 1);
				}
			}

			if (direction === "previous") {
				var index = this.getIndex();
				if (index - 1 < 0) {
					slide = slides[slideCount - 1];
					this.setIndex(slideCount - 1);
				} else {
					slide = slides[index - 1];
					this.setIndex(index - 1);
				}
			}

			return slide;
		};

		this.currentSlide = function () {
			var index = this.getIndex();
			return slides[index];
		};
	}

	// Show First Randomily Selected Slide
	$(firstSlide).attr('hidden', null);

	nextButton.on("click", function () {
		var currentSlide = slideController.currentSlide();
		var targetSlide = slideController.newSlide("next");
		$(currentSlide).attr('hidden', 'hidden');
		$(targetSlide).attr('hidden', null);
	});
	prevButton.on("click", function () {
		var currentSlide = slideController.currentSlide();
		var targetSlide = slideController.newSlide("previous");
		$(currentSlide).attr('hidden', 'hidden');
		$(targetSlide).attr('hidden', null);
	});
})();
